import { Helmet } from "react-helmet";
import { useLandingLP } from "./landing-lp.hook";
import {
  ProductTitle,
  ProductDescription,
  BuyProductPolicy,
} from "../components";

export const LandingLP = () => {
  const { t } = useLandingLP();

  return (
    <div className="bg-f5f5f5">
      <Helmet>
        <title>{t("meta.landing.title")}</title>
        <meta name="description" content={t("meta.landing.description")} />
      </Helmet>
      <div className="section-margin-large">
        <ProductTitle status="landing.section1.status" />
      </div>
      <hr className="landing-separator" />
      <div className="section-margin-large mb-md-5 pb-5">
        <ProductDescription
          descriptions={[
            "landing_lp.section2.description",
            "landing_lp.section2.description2",
            "landing_lp.section2.description3",
          ]}
        />
      </div>
      <div className="section-padding-small section4-padding bg-e5e5e5">
        <BuyProductPolicy />
      </div>
    </div>
  );
};
